import { useQuery } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import { StationeryRequestService } from "../../../../../services/company-office/StationeryRequest.service";

export const useGetDetailRequests = () => {
  const { id } = useRouteMatch().params as any;

  const response = useQuery({
    queryKey: ["stationery-request-get-detail", id],
    queryFn: () => StationeryRequestService.getStationeryRequest(id),
    refetchOnMount: "always",
  });

  return response;
};
